<template>
  <AsyncComponent v-if="componentPath"
                  :component-path="componentPath"
                  :show-load="false"
                  v-bind="$attrs"
                  v-on="$listeners"></AsyncComponent>
</template>

<script>
import AsyncComponent from './async/AsyncComponent'
export default {
  name: 'Tile',
  components: {
    AsyncComponent
  },
  props: {
    componentPath: {
      required: true,
      type: String
    }
  }
}
</script>
